import http from "../services/httpService";

const apiUrl = http.getApiUrl();
const endPoint = "/wallets";
const url = apiUrl + endPoint;

export async function getWallet(identifier, isPrimary) {
  return await http.get(url + "/" + identifier + "/" + isPrimary);
}
